// Généré par maquettes/outils/dc2react.py à partir de la maquette. Ne pas modifier à la main :
// changer maquettes/src puis relancer le script.
import React from 'react';

export default function Hero({ v }) {
  return (
    <section style={{ backgroundColor: "#FBFBFA", backgroundImage: "linear-gradient(#E9EBEE 1px, transparent 1px), linear-gradient(90deg, #E9EBEE 1px, transparent 1px)", backgroundSize: "96px 48px", borderBottom: "1px solid #E3E5E8" }}>
      <div className="m-hero" style={{ maxWidth: "1240px", margin: "0 auto", padding: "64px 24px 72px", display: "flex", flexDirection: "column", gap: "44px" }}>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "28px 56px", alignItems: "flex-end" }}>
          <div style={{ flex: "1.25 1 560px", minWidth: "0", display: "flex", flexDirection: "column", gap: "24px" }}>
            <p style={{ margin: "0", alignSelf: "flex-start", padding: "6px 10px", background: "#FFFFFF", border: "1px solid #D9DCE0", fontFamily: "'IBM Plex Mono', ui-monospace, monospace", fontSize: "13px", color: "#4A5059" }}>
              Pour les marques qui vendent en ligne, en boutique et chez leurs revendeurs
            </p>
            <h1 style={{ margin: "0", fontSize: "clamp(40px, 5vw, 70px)", fontWeight: "800", fontStretch: "76%", lineHeight: "0.98", letterSpacing: "-0.012em", textWrap: "balance" }}>
              {"Vos équipes e‑commerce passent leurs journées sur "}
              <span style={{ whiteSpace: "nowrap" }}>
                <span style={{ position: "relative", display: "inline-block", padding: "0 0.12em", background: "#FFFFFF", outline: `3px solid ${v.accent}`, outlineOffset: "-1px" }}>
                  Excel
                  <span style={{ position: "absolute", right: "-7px", bottom: "-7px", width: "10px", height: "10px", background: v.accent, border: "2px solid #FFFFFF", animation: "pulse 2.4s ease-in-out infinite" }} />
                </span>
                .
              </span>
              {" "}
              <span style={{ color: v.accent }}>
                Je leur construis le bon outil.
              </span>
            </h1>
          </div>
          <div style={{ flex: "1 1 380px", minWidth: "0", display: "flex", flexDirection: "column", gap: "22px" }}>
            <p style={{ margin: "0", fontSize: "19px", color: "#30353C", textWrap: "pretty" }}>
              Je rassemble vos Excel, vos ventes (site, Amazon, boutiques, revendeurs), votre production et votre compta dans une seule base de données. Puis j'y construis vos outils sur mesure : réappro, production, marge, pub, catalogue.
            </p>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "12px", alignItems: "center" }}>
              <a href="https://calendly.com/hello-autoria/30min?utm_source=autoria.dev&utm_medium=site&utm_content=hero" target="_blank" rel="noopener" className="lift" style={{ display: "inline-flex", alignItems: "center", minHeight: "52px", boxSizing: "border-box", padding: "14px 24px", background: v.accent, color: "#FFFFFF", textDecoration: "none", fontWeight: "700", fontSize: "17px", borderRadius: "4px" }}>
                Réserver un appel de 30 min
              </a>
              <a href="#equipes" className="lift" style={{ display: "inline-flex", alignItems: "center", gap: "8px", minHeight: "52px", boxSizing: "border-box", padding: "14px 20px", background: "#FFFFFF", color: "#15171A", textDecoration: "none", fontWeight: "600", fontSize: "17px", border: "1px solid #15171A", borderRadius: "4px" }}>
                {"Voir la démo pour mon équipe "}
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="M12 5v14M6 13l6 6 6-6" />
                </svg>
              </a>
            </div>
            <p style={{ margin: "0", fontSize: "15px", color: "#4A5059" }}>
              {"Pas encore prêt pour un appel ? "}
              <a href="/diagnostic" style={{ fontWeight: "600" }}>
                Décrivez votre besoin en 1 minute
              </a>
            </p>
            <ul style={{ margin: "0", padding: "0", listStyle: "none", display: "flex", flexWrap: "wrap", gap: "8px 20px", fontFamily: "'IBM Plex Mono', ui-monospace, monospace", fontSize: "13px", color: "#30353C" }}>
              <li style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <span style={{ width: "7px", height: "7px", background: v.accent }} />
                <span>
                  Prix fixe
                </span>
              </li>
              <li style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <span style={{ width: "7px", height: "7px", background: v.accent }} />
                Premier outil en 3 semaines
              </li>
              <li style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <span style={{ width: "7px", height: "7px", background: v.accent }} />
                Le code vous appartient
              </li>
            </ul>
          </div>
        </div>
        <figure style={{ margin: "0" }}>
          <div style={{ position: "relative", borderRadius: "16px", overflow: "hidden", background: "#DFE5F1", border: "1px solid #CDD1D6", boxShadow: "0 60px 120px -50px rgba(21, 23, 26, 0.45), 0 20px 40px -24px rgba(21, 23, 26, 0.2)" }}>
            <video ref={v.setVideo} autoPlay muted loop playsInline preload="auto" poster="video/hero-poster.jpg?v=3" aria-label="Démonstration de 35 secondes : un fichier Excel se transforme en outil sur mesure, puis quatre équipes l'utilisent pour le réappro, la marge, la pub et le catalogue." style={{ display: "block", width: "100%", height: "auto", aspectRatio: "16 / 9" }}>
              <source src="video/hero-720.mp4?v=3" type="video/mp4" media="(max-width: 640px)" />
              <source src="video/hero.mp4?v=3" type="video/mp4" />
            </video>
            <button type="button" onClick={v.toggleVideo} aria-label={v.videoLabel} style={{ position: "absolute", right: "16px", bottom: "16px", minHeight: "40px", display: "inline-flex", alignItems: "center", gap: "8px", padding: "8px 14px", background: "rgba(255, 255, 255, 0.92)", color: "#15171A", border: "1px solid #CDD1D6", borderRadius: "999px", fontFamily: "inherit", fontSize: "13px", fontWeight: "600", cursor: "pointer", boxShadow: "0 8px 20px -10px rgba(21, 23, 26, 0.4)" }}>
              {v.videoPlaying && (
                <>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                    <rect x="6" y="5" width="4" height="14" rx="1" />
                    <rect x="14" y="5" width="4" height="14" rx="1" />
                  </svg>
                  Pause
                </>
              )}
              {v.videoPaused && (
                <>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                    <path d="M7 5l12 7-12 7z" />
                  </svg>
                  Lecture
                </>
              )}
            </button>
          </div>
        </figure>
      </div>
    </section>
  );
}
